import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_URL } from '../consts';
import { IGetChatyResponse } from '../types';

export const chatyAPI = createApi({
  reducerPath: 'chatyAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL + '/api/v2/client',
  }),
  endpoints: (build) => ({
    getChaty: build.query<IGetChatyResponse, unknown>({
      query: () => ({
        url: '/pages/chaty',
        method: 'get',
      }),
    }),
  }),
});

export const { useGetChatyQuery, useLazyGetChatyQuery } = chatyAPI;

export const { getChaty } = chatyAPI.endpoints;
